import React from 'react';
import { useToggle } from 'react-use';
import { Button, Popover } from 'antd';
import cn from 'classnames';

import EditPlaylistForm from '@components/snippets/EditPlaylist/EditPlaylistForm';

const stopPropagation = (e) => e.stopPropagation();

function EditPlaylist({
  name,
  className,
  icon,
  rotate = true,
  color,
  onRename,
  onChangeColor,
  onCopy,
  onDelete,
  withoutColor,
}) {
  const [isOpen, toggle] = useToggle(false);

  return (
    <div className={cn('edit-playlist', className)} onClick={stopPropagation}>
      <Popover
        overlayClassName="edit-playlist__pop-up"
        visible={isOpen}
        onVisibleChange={toggle}
        trigger="click"
        content={
          <EditPlaylistForm
            withoutColor={withoutColor}
            initialValues={{ name, color }}
            onRename={onRename}
            onChangeColor={onChangeColor}
            onCopy={onCopy}
            onDelete={onDelete}
          />
        }
        placement="bottomLeft"
      >
        <Button
          onClick={(e) => {
            e.stopPropagation();
            toggle();
          }}
          className={cn('edit-playlist__btn', {
            'edit-playlist__btn--up': isOpen && rotate,
          })}
          type="link"
          ghost
          icon={<div className="edit-playlist__icon">{icon}</div>}
        />
      </Popover>
    </div>
  );
}

export default EditPlaylist;
